import { isAgentFamily } from '../store/graphFamily';
import { DEV_TOOLS } from '../devtools/diagnostics';
import type { GeoMeta } from '../store/sessionStore';
import type { RunContext } from '../transport/api';

/** The Agent's location rides every build (owner 12.10.2026); only `debug` is a dev-build setting, independent of opening the panel. */
export function locationContext(assistantId: string, point: { lat: number; lon: number } | null, meta?: GeoMeta | null, agentPoint?: { lat: number; lon: number } | null, agentPointSet = false, locationResetAt?: number | null): Partial<RunContext> {
  const agentDev = isAgentFamily(assistantId);
  const requestAt = Date.now();
  const selected = agentDev && agentPointSet ? agentPoint ?? null : point;
  return {
    ...(selected ? { latitude: selected.lat, longitude: selected.lon } : {}),
    ...(agentDev ? { ...(DEV_TOOLS ? { debug: true } : {}), location_request_at: requestAt, ...(locationResetAt != null ? { location_reset_at: locationResetAt } : {}) } : {}),
    ...(agentDev && selected ? { location_source: meta?.source ?? 'gps', location_at: meta?.at ?? requestAt,
      ...(meta?.source === 'chat' && meta.selectionId ? { location_selection_id: meta.selectionId } : {}),
      ...(meta?.accuracyM != null ? { location_accuracy_m: meta.accuracyM } : {}),
      // the NAME of the picked place («Московский вокзал») beside its point; GPS has none, and a chat landmark's name lives in the server's hint
      ...(meta?.source !== 'chat' && meta?.label ? { location_label: meta.label.slice(0, 120) } : {}) } : {}),
  };
}
